/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverDetailsDelete: "driver-details-delete",
  driverDetailsDisable: "driver-details-disable",
  driverDetailsEdit: "driver-details-edit",
  driverDetailsMakeAdmin: "driver-details-make-admin",
  driverDetailsRevokeAdmin: "driver-details-revoke-admin",
  driverDetailsResetPassword: "driver-details-reset-password",
  driverDetailsUploadDocument: "driver-details-upload-document",
  driverDetailsCloseAddressMap: "driver-details-close-address-map",
  driverDetailsPassword: "driver-details-password",
  driverDetailsUpdatePassword: "driver-details-update-password",
} as const;
